module.exports = __webpack_public_path__ + "static/img/thyssen.8db665f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/thyssen.png
// module id = /ic+
// module chunks = 0